/*
 * @Author: etong
 * @Date: 2021-07-29 15:54:43
 * @LastEditTime: 2021-07-29 15:57:26
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\store\modules\routerMap\views\commonPage.js
 * Think first, Program later
 */
// 代发管理订单G
const map = {
  commonForm: () => import('@/views/commonPage/commonForm'), // 通用单据表单页面
  commonList: () => import('@/views/commonPage/commonList'), // 通用列表页面
  v1_5_commonList: () => import('@/views/commonPage/v1.5/CommonList'), // 通用列表页面
  v1_5_commonForm: () => import('@/views/commonPage/v1.5/CommonForm'), // 通用表单页面
  v1_5_commonMultiTab: () => import('@/views/commonPage/v1.5/CommonMultiTab') // 通用多tab页面
}

export default map
